import { emitEvent } from "@analytics/emit";
import { EventNames } from "@analytics/enums";

export const emitReasonAction = (reason: string) => {
  emitEvent(EventNames.LOGOUT, {
    reason,
  });
};
